import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setAllowCloseOnReturnButton, setDrawer, setHeaderVisibility } from 'slices/drawer'
import { DRAWER_KEY } from 'app-constants'
import { DrawerHeader } from 'components/drawer-header'
import { ContextLoader } from 'components/context-loader'
import { EmptyOffer, Error, SpecialOffer, Success } from './components'
import {
  FIDELITY_STAGES,
  FIDELITY_STAGES_ALLOW_BACK_BUTTON,
  FIDELITY_STAGES_ALLOW_CLOSE_BUTTON,
  FIDELITY_STAGES_TITLE,
} from './constants'

function stages(props) {
  return {
    [FIDELITY_STAGES.INITIAL]: <SpecialOffer {...props} />,
    [FIDELITY_STAGES.SUCCESS]: <Success {...props} />,
    [FIDELITY_STAGES.ERROR]: <Error {...props} />,
  }
}

export function FidelityDrawer() {
  const {
    selected: { id: contractId },
    fidelity,
  } = useSelector(({ contract }) => contract)
  const { isLoading, isEligible, availablePlans = [], cpfCnpj, phone } = fidelity || {}
  const [plan] = availablePlans
  const { stage } = useSelector(({ drawer }) => drawer)
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(setHeaderVisibility(false))
    dispatch(setAllowCloseOnReturnButton(true))
  })

  function getHideCloseButton() {
    return !FIDELITY_STAGES_ALLOW_CLOSE_BUTTON.includes(stage)
  }

  function getHideBackButton() {
    return !FIDELITY_STAGES_ALLOW_BACK_BUTTON.includes(stage)
  }

  function handleDrawerClose() {
    dispatch(setDrawer(DRAWER_KEY.NONE))
  }

  function renderContent() {
    if (isLoading) return <ContextLoader fixed={false} />
    if (!isEligible || !plan) return <EmptyOffer />
    return stages({ contractId, plan, cpfCnpj, phone })[stage]
  }

  return (
    <>
      <DrawerHeader
        onClose={handleDrawerClose}
        title={FIDELITY_STAGES_TITLE[stage]}
        hideBackButton={getHideBackButton()}
        hideCloseButton={getHideCloseButton()}
        color
      />
      {renderContent()}
    </>
  )
}
